module.exports = __webpack_public_path__ + "img/09.cbce973f.webp";